import { FC } from 'react';

import * as style from './FixedBlock.css';

export interface IFixedBlockProps {
  dataMark?: string;
  tag?: 'div' | 'section' | 'p' | 'span';
  top?: number | string;
  bottom?: number | string;
  left?: number | string;
  right?: number | string;
  children: React.ReactNode;
}

export const FixedBlock: FC<IFixedBlockProps> = props => {
  const {
    tag: Tag = 'div',
    dataMark = 'FixedBlock',
    children,
    top = 0,
    bottom = 'auto',
    left = 0,
    right = 'auto',
  } = props;

  return (
    <Tag
      className={style['layout']}
      data-mark={dataMark}
      style={{
        top,
        bottom,
        left,
        right,
      }}
    >
      {children}
    </Tag>
  );
};

FixedBlock.displayName = 'FixedBlock';
